import { render, staticRenderFns } from "./pageView.vue?vue&type=template&id=71495ca1&scoped=true&"
import script from "./pageView.vue?vue&type=script&lang=js&"
export * from "./pageView.vue?vue&type=script&lang=js&"
import style0 from "./pageView.vue?vue&type=style&index=0&id=71495ca1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71495ca1",
  null
  
)

export default component.exports